import React from "react";
import PropTypes from "prop-types";
import { LabelTooltip } from "../../../LabelTooltip";

export function TankTooltip(props) {
  return (
    <LabelTooltip
      label={props.label}
      labelStyle={{ position: "absolute", top: "-45px", zIndex: 6 }}
    />
  );
}

TankTooltip.propTypes = {
  /**
   * Label to show on tooltip
   */
  label: PropTypes.string,
};

TankTooltip.defaultProps = {
  label: "Plant Tank",
};
